import React from "react";
import { observer, inject } from "mobx-react";

@inject("store")
@observer
export default class Logotype extends React.Component {

    constructor(props) {
        super(props);
    }

    render() {
        const navigationStore = this.props.store.navigation;
        const currentCustomerId = navigationStore.getCustomerId();
        return (
            <React.Fragment>
                <div className="logo desktop"
                     onClick={(e) => this.props.store.navigation.aHrefNavigation(e)}
                >
                    <a href={navigationStore.marketSettings.MarketUrl}>
                        <div className="site-logo logo-sm "><img src={navigationStore.marketSettings.LogoUrl + "?width=350"} alt={"Logotype"} /> </div>
                
                    </a>
                </div>
                <div className="logo mobile"
                     onClick={(e) => this.props.store.navigation.aHrefNavigation(e)}
                >
                    <a href={navigationStore.marketSettings.MarketUrl}>
                        <div className="site-logo logo-sm "><img src={navigationStore.marketSettings.LogoUrl + "?width=350"} alt={"Logotype"}/></div>
                
                    </a>
                </div>
            </React.Fragment>
        );
    }
}